<template>
  <b-modal
    :visible="value"
    title="Kế toán xác nhận"
    @hide="closeModal"
    ignore-enforce-focus-selector="input"
  >
    <ValidationObserver ref="formAdd">
      <form @submit.prevent="">
        <ValidationProvider rules="required" vid="statusPayment" name="Tình trạng thu tiền">
          <div class="form-group row" slot-scope="{ errors }">
            <label for="" class="col-sm-3 col-form-label"
              >Tình trạng thu tiền<span style="color: red"> *</span></label
            >
            <div class="col-sm-9">
              <Select2
                placeholder="Nhấp chọn"
                v-model="formData.statusPayment"
                :options="statusPaymentOptions"
              >
              </Select2>
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>

        <ValidationProvider
          rules="required"
          vid="statusFileContract"
          name="Tình trạng file HĐ giấy"
        >
          <div class="form-group row" slot-scope="{ errors }">
            <label for="" class="col-sm-3 col-form-label"
              >Tình trạng file HĐ giấy<span style="color: red"> *</span></label
            >
            <div class="col-sm-9">
              <Select2
                placeholder="Nhấp chọn"
                v-model="formData.statusFileContract"
                :options="statusFileContractOptions"
              >
              </Select2>
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>

        <ValidationProvider rules="" vid="note" name="Ghi chú">
          <div class="form-group row" slot-scope="{ errors }">
            <label for="" class="col-sm-3 col-form-label">Ghi chú</label>
            <div class="col-sm-9">
              <textarea v-model.trim="formData.note" class="form-control"></textarea>
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>
      </form>
    </ValidationObserver>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button variant="" @click="closeModal" class="mr-2"> Huỷ bỏ </b-button>
        <b-button variant="primary" @click="submit"> Lưu lại </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['value'],
    data() {
      return {
        show: true,
        formData: {},
        statusPaymentOptions: Config.statusPaymentOptions,
        statusFileContractOptions: Config.statusFileContractOptions,
      }
    },
    watch: {
      value() {
        if (this.value) {
          this.formData = {}
        }
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async submit() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) return
        this.$emit('submit', { ...this.formData })
      },
    },
  }
</script>

<style></style>
